import CardForItem from "../../../customUiForCs/CardForItem";

export default function RoleCard({ data }) {
  return (
    <CardForItem
      itemType={"ROLE"}
      title={data.name}
      line1={[{ text: data.description }]}
      editPath="edit-role"
      pagePath={"role"}
      itemID={data._id}
    />
  );
}
